import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { FieldValues, Control } from 'react-hook-form';
import { PriceInput } from '@/components/ui/PriceInput';

interface PriceInputFieldProps {
  control: unknown;
  name: string;
  label: string;
  placeholder: string;
  type?: string;
  disabled?: boolean;
  maxLength?: number;
  isMandatory?: boolean;
}

export const PriceInputField = ({
  control,
  name,
  label,
  placeholder,
  type = 'text',
  disabled = false,
  maxLength,
  isMandatory,
}: PriceInputFieldProps) => {
  return (
    <FormField
      control={control as Control<FieldValues>}
      name={name}
      render={({ field, fieldState }) => (
        <FormItem>
          {label && (
            <FormLabel>
              {label}{' '}
              {isMandatory && (
                <span
                  className={
                    fieldState.error?.message ? 'text-red-500' : 'text-inherit'
                  }
                >
                  *
                </span>
              )}
            </FormLabel>
          )}
          <FormControl>
            <div
              className={`${
                name === 'pricing' ? 'border rounded px-2 py-1 bg-white' : ''
              } flex items-center`}
            >
              {name === 'pricing' && (
                <span className="text-sm text-zinc-950 ml-3">₹</span>
              )}

              <PriceInput
                className={`${
                  name === 'pricing'
                    ? 'flex-1 border-none focus:ring-0 outline-none'
                    : ''
                }`}
                type={type}
                maxLength={maxLength}
                placeholder={placeholder}
                {...field}
                disabled={disabled}
                onChange={(e) =>
                  type === 'number'
                    ? field.onChange(e.target.valueAsNumber)
                    : field.onChange(e.target.value)
                }
              />
            </div>
          </FormControl>
          <FormMessage className="opacity-70" />
        </FormItem>
      )}
    />
  );
};
